import { useAccount, useReadContract } from "wagmi";
import { contractConfig } from "@config/contractsConfig";
import { useMemo } from "react";

const useDepositPoolPaused = () => {
  const { chainId, isConnected } = useAccount();

  const lrtDepositPool = useMemo(() => {
    return chainId
      ? contractConfig[chainId]?.interactionPools?.lrtDepositPool
      : undefined;
  }, [chainId]);

  const { data, isLoading, isError, refetch } = useReadContract({
    address: lrtDepositPool?.address,
    abi: lrtDepositPool?.abi,
    functionName: "paused",
    chainId,
    query: {
      enabled:
        isConnected &&
        !!lrtDepositPool &&
        !!lrtDepositPool.address &&
        !!lrtDepositPool.abi,
    },
  });

  return {
    isPaused: Boolean(data),
    isLoading,
    isError,
    refetch,
  };
};

export default useDepositPoolPaused;
